import React, { useState, useEffect, useMemo } from 'react'

import Navbar from '../../Navbar'
import MaterialReactTable from "material-react-table"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import Stack from "@mui/material/Stack"
import Chip from "@mui/material/Chip"
import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"
import { Box, Container, Typography } from '@mui/material'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';

import { getData } from "../../../services/library"

function SucursalesPuntosVenta() {
    const [sucursales, setSucursales] = useState([{}]);

    const columns = useMemo(
        () => [
            {
                accessorKey: "nombre",
                header: "Sucursal",
                size: 200,
            },
            {
                accessorKey: "pto_vta_autogas",
                header: "Autogas",
                size: 100,
            },
            {
                accessorKey: "pto_vta_hipergas",
                header: "Hipergas",
                size: 100,
            },
        ],
        [],
    )


    useEffect(() => {
        getData(`/sucursales`, setSucursales)
    }, [])

    return (
        <div>
            <Navbar />
            <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
                <Container maxWidth={false} sx={{ py: { xs: 1, md: 2 }, px: { xs: 2, md: 4 } }}>
                    {/* <Stack
                        direction={{ xs: "column", md: "row" }}
                        justifyContent="space-between"
                        alignItems={{ xs: "flex-start", md: "center" }}
                        spacing={2}
                        sx={{ mb: 1 }}
                    >
                        <Stack direction="row" spacing={1.5} alignItems="center">
                            <Box
                                sx={{
                                    width: 55,
                                    height: 55,
                                    borderRadius: 2,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    bgcolor: "primary.main",
                                    color: "primary.contrastText",
                                }}
                            >
                                <PointOfSaleIcon sx={{fontSize:30}} />
                            </Box> 
                            <Box>
                                <Typography variant="h5" component="h1">
                                    Puntos de venta de sucursal
                                </Typography>
                            </Box>
                        </Stack>
                    </Stack> */}
                    <MaterialReactTable
                        columns={columns}
                        data={sucursales ?? []}
                        localization={MRT_Localization_ES}
                        enableColumnResizing
                        columnResizeMode="onChange"
                        enablePinning
                        enableColumnFilters
                        enableGlobalFilter
                        enableHiding
                        enableDensityToggle
                        enableFullScreenToggle
                        enableStickyHeader
                        enableColumnActions
                        layoutMode="grid"
                        muiTablePaperProps={{
                            elevation: 0,
                            sx: {
                                borderRadius: 3,
                                border: "1px solid",
                                borderColor: "divider",
                                overflow: "hidden",
                            },
                        }}
                        muiTableContainerProps={{ sx: { maxHeight: "62vh" } }}
                        muiTableHeadCellProps={{
                            sx: {
                                bgcolor: "#f8fafc",
                                fontWeight: 700,
                                color: "text.primary",
                                borderBottom: "1px solid",
                                borderColor: "divider",
                            },
                        }}
                        muiTableBodyRowProps={{
                            hover: true,
                            sx: {
                                "&:hover td": { bgcolor: "action.hover" },
                            },
                        }}
                        muiTableBodyCellProps={{ sx: { borderColor: "divider" } }}
                        muiSearchTextFieldProps={{
                            placeholder: "Buscar en todos los campos...",
                            size: "small",
                            sx: { minWidth: 280 },
                            variant: "outlined",
                        }}
                        enablePagination
                        muiTablePaginationProps={{
                            rowsPerPageOptions: [10, 25, 50, 100],
                            showFirstButton: true,
                            showLastButton: true,
                        }}
                        initialState={{
                            density: "compact",
                            showGlobalFilter: true,
                            pagination: { pageSize: 10, pageIndex: 0 },
                        }}
                        displayColumnDefOptions={{
                            "mrt-row-actions": {
                                header: "Acciones",
                                size: 60,
                                muiTableHeadCellProps: { align: "center" },
                                muiTableBodyCellProps: { align: "center" },
                            },
                        }}

                        renderTopToolbarCustomActions={({ table }) => {
                            const total = table.getPrePaginationRowModel().rows.length
                            return (
                                <>
                                    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ pl: 0.5 }}>
                                        <Chip
                                            label={`${total} ${total === 1 ? "sucursal" : "sucursales"}`}
                                            size="small"
                                            color="primary"
                                            variant="outlined"
                                            sx={{ fontWeight: 600 }}
                                        />
                                    </Stack>
                                    <Typography sx={{ fontSize: 20 }}>
                                        Puntos de Venta de Sucursal
                                    </Typography>
                                </>
                            )
                        }}
                    />
                </Container>
            </Box>

        </div>
    )
}

export default SucursalesPuntosVenta